import { forwardRef, HTMLProps } from 'react';
import cx from 'classnames';
import Card from '../Card';
import styles from './Textarea.module.scss';

export interface TextareaProps extends HTMLProps<HTMLTextAreaElement> {}
function Textarea(props: TextareaProps, ref: any) {
  return (
    <Card
      {...props}
      backgroundColor="background-2"
      padding="1.5rem 1.875rem"
      as="textarea"
      className={cx(props.className, styles.root)}
      ref={ref}
    />
  );
}

export default forwardRef(Textarea);
